var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsMicFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kbep7n6nba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368 0v1600H0V0h1368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1la51y0d7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.667 24a2.667 2.667 0 0 1 2.648 2.356l.018.31V32c0 9.408-6.96 17.19-16.01 18.48l.01.187v2.666h5.334a2.667 2.667 0 0 1 .31 5.316l-.31.018h-16a2.667 2.667 0 0 1-.311-5.316l.31-.018H16v-2.666c0-.064.002-.127.007-.19C7.164 49.218.319 41.759.01 32.643L0 32v-5.333a2.667 2.667 0 0 1 5.315-.311l.018.31V32c0 7.364 5.97 13.333 13.334 13.333 7.17 0 13.018-5.66 13.32-12.755L32 32v-5.333A2.667 2.667 0 0 1 34.667 24zm-16-24a8 8 0 0 1 8 8v24a8 8 0 1 1-16 0V8a8 8 0 0 1 8-8z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kbep7n6nba)",
    transform: "translate(-496 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1la51y0d7b)",
    transform: "translate(509.79 339.124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h37.333v58.667H0V0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMicFilled);
export default __webpack_public_path__ + "static/media/icons-mic-filled.fa7fcbf50ce2fbfe335254469e6b6ae3.svg";
export { ForwardRef as ReactComponent };